import React, { Component } from "react";
import { Modal, Row, Col } from "antd";
import "./Modal.css";
import PlanoConta1 from '../imagens/CadPlanoConta/PlanoConta1.png';
import PlanoConta2 from '../imagens/CadPlanoConta/PlanoConta2.png';
import PlanoConta3 from '../imagens/CadPlanoConta/PlanoConta3.png';
import PlanoConta4 from '../imagens/CadPlanoConta/PlanoConta4.png';
import PlanoConta5 from '../imagens/CadPlanoConta/PlanoConta5.png';
import PlanoConta6 from '../imagens/CadPlanoConta/PlanoConta6.png';

export default class CadPlanoConta extends Component {

    render() {

        const { isOpen, onClose } = this.props;

        return (
            <Modal
                title="Como utilizar o Cadastro de Planos de Contas"
                className="modal"
                visible={isOpen}
                destroyOnClose
                onCancel={onClose}
                footer={null}
                width="50%"
                style={{ top: 10 }}
            >
                <Row>
                    <Col xs={24}>
                        <p>Para acessar o Cadastro de Planos de Contas:  </p>

                        <div className="image-wrapper">
                            <img className="img_smaller" src={PlanoConta1} alt="Plano 1"/>
                        </div>

                        <div className="gray_bar"></div>  

                        <div className="image-wrapper">
                            <img src={PlanoConta2} alt="Plano 2"/>
                        </div>                                            

                        <h3>No cadastro de Planos de Contas nós temos:</h3>
                        <ol>
                            <li>Cadastrar um novo Plano de Conta.</li>
                            <li>Filtro para busca de um Plano de Conta usando a descrição.</li>
                            <li>Tabela exibindo os Planos de Conta que foram cadastradas até agora.</li>
                            <li>Botões auxiliares para alterar/excluir o Plano de Conta.</li>
                            <li>Paginação da tabela de Plano de Conta.</li>
                        </ol>

                        <div className="gray_bar"></div>

                        <h3>Como cadastrar um novo Plano de Conta</h3>

                        <p>
                            Primeiro você deve clicar no botão de "Adicionar" para começar o cadastro. 
                        </p>  
                        <div className="image-wrapper">
                            <img src={PlanoConta3} alt="Plano 3"/>
                        </div>        
                        <div className="image-wrapper">
                            <img src={PlanoConta4} alt="Plano 4"/>
                        </div>                                             
                        <p>
                            Alguns campos do cadastro precisam de maior atenção. Um deles é o campo de Nível da Conta. Esse campo serve para que o gestor possa desmembrar
                            as contas, para que o controle dos lançamentos financeiros fique mais detalhado. Um exemplo é a imagem abaixo onde despesas são
                            desmembradas em sub contas de forma mais detalhada para facilitar o controle dos lançamentos.
                        </p>
                        <div className="image-wrapper">
                            <img src={PlanoConta5} alt="Plano 5"/>
                        </div> 

                        <p>
                            Outro campo importante é o tipo de conta, que define se lançamentos feitos para esse plano de conta são saídas ou entradas no caixa. É importante
                            definir as contas de pagamento ou recebimento de forma correta. 
                        </p>
                        <p>
                            O campo marcador de "Recebe Lançamento" define se o plano de conta é uma opção disponível para ser feito um lançamento financeiro. Normalmente
                            contas que servem como agrupadores de sub contas não deve permitir que lançamentos sejam feitos.  
                        </p>

                        <p>
                            O marcador de "Conta Operacional" define se aquela conta é utilizada para lançamentos relacionados a operação diária da empresa. Esse marcador 
                            serve somente para relatórios, no caso se o gestor quiser tirar um relatório de apenas contas operacionais, ele precisa marcar essa opção no
                            plano de contas.
                        </p>

                        <p>
                            Depois de preencher todas as informações, basta clicar em "Salvar" para terminar o cadastro do novo Plano de Conta. Lembresse que os campos 
                            com um asterisco(*) são obrigatórios. 
                        </p>

                        <div className="gray_bar"></div>     

                        <h3>Como Excluir/Alterar um Plano de Conta</h3>

                        <p>
                            Para excluir/alterar um Plano de Conta, basta utilizar os botões auxiliares que estão na tabela mostrando todos os Planos de Conta já cadastrados.
                            Lembresse que não é possível excluir um Plano de Conta que ja possui lançamentos financeiros atribuídos a ele. 
                        </p>   

                        <div className="image-wrapper">
                            <img src={PlanoConta6} alt="Plano 6"/>
                        </div>                                         

                    </Col>
                </Row>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/tutoriais/CadPlanoConta.js